<template>
  <v-card>
    <v-card-text>
      <v-form>
        <v-select
          :items="identificationTypes"
          item-text="description"
          item-value="code"
          v-model="identification_type_code"
          label="Tipo Identificación"
        ></v-select>
        <v-text-field
          label="Identificación"
          id="Identification"
          v-model="identification"
          type="number"
        />
        <v-text-field label="Nombre" id="Name" v-model="name" />
        <v-card-actions class="d-flex flex-justify-end">
          <v-btn
            color="success"
            class="ma-2"
            block
            :outlined="$vuetify.breakpoint.mdAndUp"
            @click="onSave"
          >
            Guardar
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  name: "PersonManual",

  components: {
    //
  },

  data: () => ({
    person: null,
    identificationTypes: null,
    identification_type: null,
    identification_type_code: null,
    identification: null,
    name: null
  }),

  methods: {
    onSave() {
      let index = this.identificationTypes.findIndex(
        type => type.code === this.identification_type_code
      );
      let obj = {
        name: this.name,
        identification_type: this.identificationTypes[index]
          ? this.identificationTypes[index].url
          : null,
        identification_type_code: this.identification_type_code,
        identification: this.identification
      };
      this.$emit("save", obj);
    }
  },
  mounted() {
    //Get Identification Types
    if (!this.identificationsTypes) {
      // eslint-disable-next-line
      this.$bRoot.search("/data/identification_types", null, null)
        .then(response => {
          this.identificationTypes = response.data.results;
        })
        .catch(error => {
          if (!this.$bRoot.errors) {
            this.$bRoot.setError(error);
          }
        });
    }
  }
};
</script>

<style></style>
